import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Button } from "./ui/button";
import api, { apiErr } from "../lib/api";
import { toast } from "sonner";

export function ChangePasswordDialog({ open, onClose, forced = false, onDone }) {
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [cf, setCf] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (nw.length < 6) return toast.error("Yeni şifre en az 6 karakter olmalı");
    if (nw !== cf) return toast.error("Şifreler eşleşmiyor");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      toast.success("Şifre güncellendi");
      setCur(""); setNw(""); setCf("");
      onDone && onDone();
      onClose && onClose();
    } catch (e) {
      toast.error(apiErr(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o && !forced) onClose && onClose(); }}>
      <DialogContent className="max-w-md rounded-2xl" data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-navy-900">{forced ? "Şifrenizi Belirleyin" : "Şifre Değiştir"}</DialogTitle>
        </DialogHeader>
        {forced && <p className="text-sm text-slate-500 -mt-2">Güvenliğiniz için ilk girişte şifrenizi değiştirmeniz gerekir.</p>}
        <div className="space-y-3">
          <div className="space-y-1.5">
            <Label className="text-xs uppercase text-slate-500">Mevcut Şifre</Label>
            <Input data-testid="cp-current" type="password" value={cur} onChange={(e) => setCur(e.target.value)} className="rounded-xl" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs uppercase text-slate-500">Yeni Şifre</Label>
            <Input data-testid="cp-new" type="password" value={nw} onChange={(e) => setNw(e.target.value)} className="rounded-xl" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs uppercase text-slate-500">Yeni Şifre (Tekrar)</Label>
            <Input data-testid="cp-confirm" type="password" value={cf} onChange={(e) => setCf(e.target.value)} className="rounded-xl" />
          </div>
        </div>
        <DialogFooter className="gap-2">
          {!forced && <Button variant="outline" className="rounded-xl" onClick={onClose}>İptal</Button>}
          <Button data-testid="cp-submit" onClick={submit} disabled={busy} className="rounded-xl bg-navy-900 text-white">
            {busy ? "Kaydediliyor…" : "Kaydet"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
